define((require) => {
    "use strict";

    var Preconditions           = require("shared/util/Preconditions"),
        BreakpointGroup         = require("shared/ui/breakpoint/BreakpointGroup"),
        LocalizationGroup       = require("shared/services/localization/LocalizationGroup"),
        GroupLocaleNavView      = require("editor/ui/experience/editor/GroupLocaleNavView"),
        GroupBreakpointNavView  = require("editor/ui/experience/editor/GroupBreakpointNavView");

    /**
     * A factory for creating specific/concrete <tt>GroupNavView</tt>'s.
     *
     * @class GroupNavViewFactory
     */
    return {

        create: function(options) {
            var group = options.model,
                ViewClass = null;

            Preconditions.checkArgument(group, "A model of group instance must be passed in as an option property");

            switch (group.get("type")) {
                case LocalizationGroup.type:
                    options.identifierInFront = false;
                    ViewClass = GroupLocaleNavView;
                    break;

                case BreakpointGroup.type:
                    options.identifierInFront = true;
                    ViewClass = GroupBreakpointNavView;
                    break;

                default:
                    break;
            }

            return new ViewClass(options);
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/GroupNavViewFactory.js